import type { FsnbDiffSide } from '@shared/api';
import { fmtNum } from '@shared/lib/smetaLabels';
import { changedFieldLabel } from '../normBaseLabels';
import { Minus, Muted, Plus, Tilde } from './styles';

export function DiffLine({ side }: { side: FsnbDiffSide | undefined }) {
  if (!side) return <Muted>—</Muted>;
  return (
    <>
      <Plus>+{fmtNum(side.added)}</Plus> новых · <Tilde>~{fmtNum(side.changed)}</Tilde> изменено ·{' '}
      <Minus>−{fmtNum(side.removed)}</Minus> исключено
    </>
  );
}

export function fieldsText(fields: Record<string, number> | undefined): string {
  const entries = Object.entries(fields ?? {}).filter(([, n]) => n > 0);
  if (entries.length === 0) return '';
  return entries
    .sort((a, b) => b[1] - a[1])
    .map(([f, n]) => `${changedFieldLabel(f)} — ${fmtNum(n)}`)
    .join('; ');
}
